import React from 'react'
import {
  CssBaseline,
  ThemeProvider
} from '@material-ui/core'
import { Routes, Route, Link } from 'react-router-dom'
import { darkTheme } from './theme'
import {
  TrilobitesPuzzleApp,
  TrilobitesViewerApp
} from './modules/app'

const Picker = () => {
  return (
    <ul className="picker">
      <li>
        <Link to="/viewer">Model Viewer</Link>
      </li>
      <li>
        <Link to="/puzzle">Puzzles</Link>
      </li>
    </ul>
  )
}

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Picker />} />
        <Route
          path="/viewer"
          element={<TrilobitesViewerApp />}
        />
        <Route
          path="/puzzle"
          element={<TrilobitesPuzzleApp />}
        />
      </Routes>
    </ThemeProvider>
  )
}

export default App
